 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		46: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"e6d7d249d0a760c5778251b112e92eb5b9048402","4":"component---src-pages-404-js","5":"component---src-pages-about-mdx","6":"component---src-pages-components-accordion-mdx","7":"component---src-pages-components-anchor-links-mdx","8":"component---src-pages-components-art-direction-index-mdx","9":"component---src-pages-components-article-card-mdx","10":"component---src-pages-components-aside-mdx","11":"component---src-pages-components-caption-mdx","12":"component---src-pages-components-code-blocks-mdx","13":"component---src-pages-components-do-dont-example-mdx","14":"component---src-pages-components-do-dont-row-mdx","15":"component---src-pages-components-feature-card-mdx","16":"component---src-pages-components-feedback-dialog-mdx","17":"component---src-pages-components-gif-player-mdx","18":"component---src-pages-components-grid-mdx","19":"component---src-pages-components-image-card-mdx","20":"component---src-pages-components-image-gallery-mdx","21":"component---src-pages-components-inline-notification-mdx","22":"component---src-pages-components-markdown-mdx","23":"component---src-pages-components-medium-posts-mdx","24":"component---src-pages-components-page-description-mdx","25":"component---src-pages-components-resource-card-mdx","26":"component---src-pages-components-tabs-mdx","27":"component---src-pages-components-title-mdx","28":"component---src-pages-components-video-mdx","29":"component---src-pages-contact-mdx","30":"component---src-pages-contributions-mdx","31":"component---src-pages-demo-index-mdx","32":"component---src-pages-gallery-index-mdx","33":"component---src-pages-getting-started-index-mdx","34":"component---src-pages-guides-configuration-mdx","35":"component---src-pages-guides-mdx-mdx","36":"component---src-pages-guides-navigation-sidebar-mdx","37":"component---src-pages-guides-navigation-tabs-mdx","38":"component---src-pages-guides-npm-scripts-mdx","39":"component---src-pages-guides-shadowing-mdx","40":"component---src-pages-guides-styling-mdx","41":"component---src-pages-index-mdx","42":"component---src-pages-instagram-mdx","43":"component---src-pages-privacy-mdx","44":"component---src-pages-test-spacing-audit-mdx"}[chunkId]||chunkId) + "-" + {"1":"b1cc5098d81e9a60c7d6","4":"bc7c3f5434b9cf9f7447","5":"9f995acc3fefa5a70b80","6":"29903a53c6f466206a75","7":"eb4bb21bdfdbb8b507d7","8":"bf108e854627d6740e69","9":"e7a612dc08cbd61c3da0","10":"061ac1c80ae7ff128330","11":"81d051c4b074a60f7d77","12":"819bec27588f86281e9c","13":"8a7964b399972e5cd066","14":"53cb24d3e2e75a9eada6","15":"751b569bd3516cd8589b","16":"d4fc2160f9080d3ef0c5","17":"49b4c9ac08149272a0e7","18":"1b63e5b2e2d2936110a0","19":"c8bf289924e66719f3de","20":"2a22cb05cb2bacde4566","21":"39a05545e392bd6cc744","22":"7d425c98d2284d4ffe12","23":"8f7dbfede875c6e0db99","24":"e3632bef0b167d821c36","25":"ea95b39951eeda4f5e5d","26":"873492237ecfe8365881","27":"edc49f2b27e872b78222","28":"c52d779c04a09086cfaf","29":"2319de07e927bd1c2f18","30":"f04c7d81742441f1f6e3","31":"effa3ec9bf70b87cfa9d","32":"ef0615a60784324c05ef","33":"c40a60391c07a11d31d5","34":"d9b9b2f18864730dc743","35":"2c9efdcc283d3f40e4a6","36":"6935ed70a9ae43418663","37":"f2becdc054b8bccaa7dc","38":"fc0c306f3d77202965ea","39":"b99496a096b682c36b66","40":"e69e4d25460aeb2b491b","41":"0ac147791027868d6dd0","42":"94fefff7249aae8e1f05","43":"b826756e4471d4b3c74f","44":"236cd3fdb4948e0c18e8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
